export default __webpack_public_path__ + "static/media/Screenshot (2).c584bcb9.png";